import { useState } from "react";
import HexModal from "../../../../../../components/HexModal";
import { getLabel } from "../../../../../../hooks/use-labels";
import AddressForm from "./AddressForm";

import HexMap from "../../../../../../components/HexMap";
import "./style.css";
import { saveOrderDetails } from "../../cart-details-utils";

const AddressModal = ({ onClose, address, onSave, error }) => {
  const [addressDetails, setAddressDetails] = useState(address);
  const [mapModal, setMapModal] = useState(true);
  const [deliveryLocationError, setDeliveryLocationError] = useState(
    error || ""
  );

  const { latitude, longitude, address1 } = addressDetails;

  const saveLocation = (address) => {
    setAddressDetails(address);
    setMapModal(false);
  };

  const setOrderInfo = (address) => {
    saveOrderDetails(
      {
        successCB: () => {
          setDeliveryLocationError("");
        },
        errorCB: ({ message, code }) => {
          if (code.includes("address")) {
            setDeliveryLocationError(message);
          }
        },
      },
      { deliveryAddress: address }
    );
  };

  if (mapModal) {
    return (
      <HexModal
        open={true}
        onClose={onClose}
        closable={true}
        className="pin-location-modal"
        title={getLabel("deliveryAddressLabel")}
      >
        <HexMap
          mapProps={{
            latitude,
            longitude,
            addressText: address1,
            onChangeAddress: setOrderInfo,
          }}
          modal={true}
          onClose={onClose}
          onSave={saveLocation}
          mapError={deliveryLocationError}
        />
      </HexModal>
    );
  }

  return (
    <HexModal
      title={getLabel("deliveryAddressLabel")}
      onClose={onClose}
      closable={true}
      open={true}
      modalClass="address-modal"
    >
      <AddressForm address={addressDetails} onSave={onSave} />
    </HexModal>
  );
};

export default AddressModal;
